export default "__VITE_ASSET__Dyd0oAyc__"